<template>
	<div class="action-flow-node action-flow-node-call" style="height: 280px;">
		<div class="action-flow-title">Query AI</div>
		<div class="action-flow-hint">Ask a question to the DevXene AI model about data or files.</div>
		
		<ActionParamHint label="Query Type" hint="What type of query to make." param-class="param-config"
			param-input-type="select"  param-input-label="Query Type" @param-change="handleParamChange"
			:param-input-options="[{ value: 'text', label: 'Text Query' }, { value: 'data', label: 'Data Query' }, { value: 'file', label: 'File Query' }]"
			:param-input-value="parameters.queryType"
		/>
		<ActionParamHint label="Prompt" hint="Question to ask the AI model. You can feed in more than one object to this input.." param-class="param-tgt"
			param-input-type="textarea"  param-input-label="URL" @param-change="handleParamChange"
			:param-input-value="parameters.prompt"
		/>
		<ActionParamHint label="Response Message" hint="Text message response from the AI model." param-class="param-src" />
		<ActionParamHint label="Response Data" hint="Data response from the AI model if applicable." param-class="param-src" />
		<ActionParamHint label="Failure" hint="Flow continues here when the AI model cannot answer this question." param-class="param-src" />
		
		<Handle type="target" id="tgt-prompt" :position="Position.Left" style="top: 135px;" />
		<Handle type="source" id="src-message" :position="Position.Right" style="top: 175px;" />
		<Handle type="source" id="src-data" :position="Position.Right" style="top: 215px;" />
		<Handle type="source" id="src-failure" :position="Position.Right" style="top: 255px;" />
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	queryType: '',
	prompt: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			queryType: newNodeData.data?.queryType || '',
			prompt: newNodeData.data?.prompt || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	switch (paramData.label.toLowerCase()) {
		case 'query type':
			parameters.value.queryType = paramData.value;
			break;
		case 'prompt':
			parameters.value.prompt = paramData.value;
			break;
		default:
			console.error(`Unknown parameter label: ${paramData.label}`);
			return;
	}
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>
	